import { Box, BoxProps, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export type HeaderProps = BoxProps;

/**
 * Header component that displays the logo and description
 *
 * @param boxProps
 */
export const Header: React.FC<HeaderProps> = ({ ...boxProps }) => {
  const { t } = useTranslation('forms');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      {...boxProps}
    >
      <Stack spacing="xs" align="center">
        <Text fz="xl" fw={600}>
          {t('external.descriptionLine1')}
        </Text>
        <Text fz="lg" fw={600} align="center">
          {t('external.descriptionLine2')}
        </Text>
      </Stack>
    </Box>
  );
};
